/**
 * Ring buffer of the app's recent runtime/console errors — the evidence Debug mode sends along.
 *
 * The preview already reports every crash to PreviewPane; before this, each report was consumed by
 * the auto-fix toast and thrown away, so by the time a learner typed "the jump is broken" the very
 * error that explained it was gone. Keeping the last few means Debug mode can hand the model the
 * symptom AND the stack trace, instead of making it rediscover the crash from source.
 */

export interface CapturedError {
  message: string;
  at: number;
}

const MAX = 20;
const errors: CapturedError[] = [];

export function recordRuntimeError(message: string, stack?: string): void {
  const line = stack ? `${message}\n${stack.split('\n').slice(0, 3).join('\n')}` : message;
  errors.push({ message: line.slice(0, 1000), at: Date.now() });
  if (errors.length > MAX) errors.shift();
}

/** Newest last, matching how the server presents them to the model. */
export function recentRuntimeErrors(): string[] {
  return errors.map(e => e.message);
}

export function hasRuntimeErrors(): boolean {
  return errors.length > 0;
}
